import { FaBars } from "react-icons/fa6";

export const Header = ({ children, showToggleSidebar = true, toggleSidebar }) => {
  return (
    <header
      className="sticky top-0 z-30 h-16"
      style={{
        background: "rgba(6, 13, 31, 0.8)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        borderBottom: "1px solid rgba(51, 65, 85, 0.25)",
      }}
    >
      <div className="flex items-center justify-between p-4 lg:px-6">
        {/* Mobile Toggle — hanya muncul saat sidebar tidak terlihat di mobile */}
        {showToggleSidebar && (
          <button
            onClick={toggleSidebar}
            className="lg:hidden w-10 h-10 rounded-xl flex items-center justify-center text-slate-400 hover:text-ocean-400 hover:bg-slate-800/60 transition-all duration-200 active:scale-95"
            aria-label="Buka menu"
          >
            <FaBars className="text-lg" />
          </button>
        )}

        {/* Content (judul halaman + tombol aksi) */}
        <div className="flex items-center justify-between w-full gap-4">
          {children}
        </div>
      </div>
    </header>
  );
};